/**
 * Aggregated customers counts actions
 */
import * as t from './actionTypes';

/**
 * Request for aggregated customers counts failed
 *
 * @param {Object} error
 *
 * @return {Object}
 */
export const customersCountsAggregatedFailed = error => ({
  type: t.CUSTOMERS_COUNTS_AGGREGATED_FAILED,
  payload: error,
});

/**
 * Trigger a request for aggregated customers counts data
 *
 * @return {Object}
 */
export const customersCountsAggregatedRequested = () => ({
  type: t.CUSTOMERS_COUNTS_AGGREGATED_REQUESTED,
});

/**
 * Request for aggregated customers counts has been successful
 *
 * @param {Array} data
 *
 * @return {Object}
 */
export const customersCountsAggregatedSucceeded = data => ({
  type: t.CUSTOMERS_COUNTS_AGGREGATED_SUCCEEDED,
  payload: data,
});
